import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IApisVerifyUsernameResponse } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { ILocateUserEntity } from '@intigral/domain/lib/entity';

export interface ILocateUsernameUseCase {
    execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
    ): Promise<ILocateUserEntity['data']>;
}

export class LocateUsernameUseCase implements ILocateUsernameUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        lang: string,
        apiToken: { [key: string]: string },
    ): Promise<ILocateUserEntity['data']> {
        const response = await this.authRepo.locateUser(username, lang, apiToken);
        return response.data;
    }
}
